import React, {Component} from 'react';
import {FormContext} from "../Form/FormContext";
import Input from "./base";

export default class InputContainer extends Component {

    render() {
        return (
            <FormContext.Consumer>
                {formContext => {
                    return <Input {...this.props} formContext={formContext} />
                }}
            </FormContext.Consumer>
        );
    }
}
